module.exports = __webpack_public_path__ + "img/settings-04.884a7ded.svg";